<template>
  <div class="start__materials-fields">
    <select class="start__materials-select" v-model="selected.id">
      <option value="" selected>Выберите материал</option>
      <option v-for="choice in choices" :selected="(selected == choice.id)" :value="choice.id" :key="choice.id">{{ choice.name }}</option>
    </select>
    <label class="has-float-label">
      <input type="number" v-model.number="selected.amount" placeholder="Написать..." class="start__materials-input"/>
      <span>Кол-во</span>
    </label>
    <button class="start__materials-add" @click.prevent="addFunction">+</button>
  </div>
</template>

<script>
export default {
  name: 'Material',
  props: {
    choices: Array,
    selected: Object,
    addFunction: Function
  }
}
</script>
